<file-upload name="upload"
             [(ngModel)]="listFiles"
             [control]="fileUploadControl"
             [animation]="false"
             [multiple]="isMultiple"
             accept="{{mimeTypes}}"
             (ngModelChange)="addFiles()">
  <ng-template #placeholder>
    <div class="upload-icon d-flex justify-content-center align-items-center fs-4">
      <i class="bi bi-cloud-upload" aria-hidden="true"></i>
    </div>
    <div>
      <b>Drag and drop</b> files<br> or click here
    </div>
  </ng-template>
</file-upload>
